import React from 'react';
import { Heading, Main, SectionLeft, SectionRight, SubHeading } from './reviewAndLodge.style';

import { useNavigate } from 'react-router-dom';

import backgroundImg from '../../../assets/PNG/review-and-lodge.png';
import backgroundImgCompress from '../../../assets/PNG/review-and-lodge-compress.png';
import useImageLoader from '../../../hooks/useImageLoader';
import { IntlMessages } from '../../../helper/langHelper';
import { ResponsiveButton } from '../../../settings/appStyle/global.style';

const ReviewAndLodge = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/documentUpload');
  };
  const reviewAndLodgeBg = useImageLoader(backgroundImgCompress, backgroundImg);

  return (
    <Main>
      <SectionLeft>
        <Heading>
          <IntlMessages id="review.lodge.title" />
        </Heading>
        <SubHeading>
          <IntlMessages id="review.lodge.subtitle" />
        </SubHeading>
        <ResponsiveButton onClick={handleClick}>
          {' '}
          <IntlMessages id="button.next" />
        </ResponsiveButton>
      </SectionLeft>
      <SectionRight bg={reviewAndLodgeBg} />
    </Main>
  );
};

export default ReviewAndLodge;
